import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'src/app/pages/ui-components/dialog/dialog.component';

@Component({
  selector: 'app-term-conditions',
  templateUrl: './term-conditions.component.html',
  styleUrls: ['./term-conditions.component.scss'],
  


})
export class TermConditionsComponent {
  constructor(
    public dialogRef: MatDialogRef<TermConditionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: boolean,

  ) {
    console.log(data)
  }
 
  ok(){
    this.data = true
  }
}
